<template>
  <v-container class="fill-height align-content-center justify-center">
    <v-card class="pa-4">
      <v-card-title>Hello, Please enter your login credentials</v-card-title>
      <v-text-field
        v-model="form.name"
        outlined
        type="text"
        label="Name"
      ></v-text-field>
      <v-text-field
        v-model="form.company_name"
        outlined
        type="text"
        label="Company"
      ></v-text-field>
      <v-text-field
        v-model="form.email"
        outlined
        type="text"
        label="E-mail"
      ></v-text-field>
      <v-text-field
        v-model="form.password"
        outlined
        type="password"
        label="Password"
      ></v-text-field>
      <v-text-field
        v-model="form.password_confirmation"
        outlined
        type="password"
        label="Confirm Password"
      ></v-text-field>
      <v-select :items="roles" outlined label="Select a role" />
      <v-card-actions>
        <v-btn @click="register">Register</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import User from "@/store/modules/user";
import { roles } from '@/constants';

export default {
  name: "Register",
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        company_name: "",
        password_confirmation: "",
      },
      errors: [],
      roles,
    };
  },
  methods: {
    async register() {
      try {
        const response = await User.register(this.form);
        debugger;
        this.$router.redirect({ name: "login" });
      } catch (error) {
        if (error.response.status === 422) {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        }
      }
    },
  },
};
</script>
